import {Chip, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {CustomATage} from "../ExternalSourceManagement/ExternalSourceTable";
import {convertDateToTimeString} from "../utils/cert-helper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";

/**
 * Import log table, shared by every Amendment #1 A5 value set.
 *
 * Identical to OrgTypeLogsTable/SuffixLogsTable apart from the prop name, which is why it is one
 * component here instead of one per value set.
 *
 * @date: 08/11/26
 * @copy: (C) Copyright 2026 MaxMD Corporation, All Rights Reserved.
 */

const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold',
})
const StyledTableContainer = styled(TableContainer)({
    maxHeight: '600px',
    '& .MuiTableCell-root': {
        paddingLeft: '4px',
        paddingRight: '4px'
    }
})

export default function TerminologyLogsTable(props) {
    const logs = props.logs;

    return (
        <StyledTableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Data Source</StyledTableCell>
                        <StyledTableCell>Description</StyledTableCell>
                        <StyledTableCell>Data Path</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Imported Record Count</StyledTableCell>
                        <StyledTableCell>Created Time</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Status</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {logs && logs.map((log, i) => {
                        return (
                            <TableRow key={i}>
                                <TableCell>{log.datasource}</TableCell>
                                <TableCell>{log.description}</TableCell>
                                <TableCell sx={{ maxWidth: '350px', wordBreak: 'break-all'}}><CustomATage size='14px' path={log.dataPath} /></TableCell>
                                <TableCell sx={{ textAlign: 'center'}}>
                                    {/* Zero is the failure worth noticing: a value set whose include named only a
                                        system used to import empty and still report success. */}
                                    {log.completed && log.importedRecordCount === 0
                                        ? <Chip size='small' variant='outlined' color='warning' label="0" />
                                        : log.importedRecordCount}
                                </TableCell>
                                <TableCell>{convertDateToTimeString(log.createdTs)}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    {log.completed ? <Chip variant='outlined' label="COMPLETED" color="success" icon={<CheckCircleIcon/>}/>
                                        : <Chip label="UNCOMPLETED" color="warning" variant='outlined'/>}
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </StyledTableContainer>
    )
}
